<div
  *ngIf="loading$ | async"
  class="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center z-[999] backdrop-blur bg-white/30"
  [ngClass]="class">
  <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" [style]="{ width: '100px', height: '100px' }"> </p-progress-spinner>
</div>
